import {
  arst_changeSent,
  arst_insertDroppedItem,
  arst_loadData,
  arst_patchData,
  arst_removeGroupingFactor,
  arst_removeOperation,
  arst_setAnalysisMethod,
  arst_setScaffoldColWidth,
  arst_setScaffoldRowHeight,
  arst_setTlfViewMode,
  arst_setViewItem,
  arst_toggleGroupLabelVisibility,
  arst_toggleInlineRowHeader,
  arst_toggleInlineWithPreviousLevel,
  arst_toggleSpaceAfterGroup,
  arst_toggleSpaceAfterSubGroups,
  arst_updateScaffold,
} from "./functions";
import {
  ARST_CHANGE_SENT,
  ARST_INSERT_COLUMN_AFTER,
  ARST_INSERT_COLUMN_BEFORE,
  ARST_INSERT_OPERATION_COLUMN_AFTER,
  ARST_INSERT_OPERATION_COLUMN_BEFORE,
  ARST_INSERT_OPERATION_ROW_AFTER,
  ARST_INSERT_OPERATION_ROW_BEFORE,
  ARST_INSERT_OPERATION_SUBGROUP,
  ARST_INSERT_ROW_AFTER,
  ARST_INSERT_ROW_BEFORE,
  ARST_INSERT_SUBGROUP,
  ARST_LOAD_DATA,
  ARST_PATCH_DATA,
  ARST_REMOVE_GROUPINGFACTOR,
  ARST_REMOVE_OPERATION,
  ARST_SET_ANALYSIS_METHOD,
  ARST_SET_SCAFFOLD_COL_WIDTH,
  ARST_SET_SCAFFOLD_ROW_HEIGHT,
  ARST_SET_TLF_VIEW_MODE,
  ARST_SET_VIEW_ITEM,
  ARST_TOGGLE_GROUP_LABEL_INLINE,
  ARST_TOGGLE_GROUP_LABEL_VISIBILITY,
  ARST_TOGGLE_INLINE_WITH_PREVIOUS_LEVEL,
  ARST_TOGGLE_SPACE_AFTER_GROUP,
  ARST_TOGGLE_SPACE_AFTER_SUBGROUPS,
  ARST_UPDATE_SCAFFOLD,
  ArsTableAction,
  ArsTableState,
} from "./interface";

/**
 * Reducer function to manage state updates for the ArsTable component.
 *
 * @param state - Current state of the ArsTable
 * @param action - Action to be performed on the state
 * @returns Updated state
 */
export const arsTableReducer = <T>(
  state: ArsTableState<T>,
  action: ArsTableAction<T>,
): ArsTableState<T> => {
  switch (action.operation) {
    case ARST_CHANGE_SENT:
      return arst_changeSent(state);
    case ARST_INSERT_COLUMN_AFTER:
    case ARST_INSERT_COLUMN_BEFORE:
    case ARST_INSERT_OPERATION_COLUMN_AFTER:
    case ARST_INSERT_OPERATION_COLUMN_BEFORE:
    case ARST_INSERT_OPERATION_ROW_AFTER:
    case ARST_INSERT_OPERATION_ROW_BEFORE:
    case ARST_INSERT_OPERATION_SUBGROUP:
    case ARST_INSERT_ROW_AFTER:
    case ARST_INSERT_ROW_BEFORE:
    case ARST_INSERT_SUBGROUP:
      return arst_insertDroppedItem(state, action);
    case ARST_LOAD_DATA:
      return arst_loadData(state, action);
    case ARST_PATCH_DATA:
      return arst_patchData(state, action);
    case ARST_REMOVE_GROUPINGFACTOR:
      return arst_removeGroupingFactor(state, action);
    case ARST_REMOVE_OPERATION:
      return arst_removeOperation(state, action);
    case ARST_SET_ANALYSIS_METHOD:
      return arst_setAnalysisMethod(state, action);
    case ARST_SET_SCAFFOLD_COL_WIDTH:
      return arst_setScaffoldColWidth(state, action);
    case ARST_SET_SCAFFOLD_ROW_HEIGHT:
      return arst_setScaffoldRowHeight(state, action);
    case ARST_SET_TLF_VIEW_MODE:
      return arst_setTlfViewMode(state, action);
    case ARST_SET_VIEW_ITEM:
      return arst_setViewItem(state, action);
    case ARST_TOGGLE_GROUP_LABEL_VISIBILITY:
      return arst_toggleGroupLabelVisibility(state, action);
    case ARST_TOGGLE_INLINE_WITH_PREVIOUS_LEVEL:
      return arst_toggleInlineWithPreviousLevel(state, action);
    case ARST_TOGGLE_GROUP_LABEL_INLINE:
      return arst_toggleInlineRowHeader(state, action);
    case ARST_TOGGLE_SPACE_AFTER_GROUP:
      return arst_toggleSpaceAfterGroup(state, action);
    case ARST_TOGGLE_SPACE_AFTER_SUBGROUPS:
      return arst_toggleSpaceAfterSubGroups(state, action);
    case ARST_UPDATE_SCAFFOLD:
      return arst_updateScaffold(state, action);
  }
};
